import { RecipeManagementActionTypes } from './constants';

// Types for adding/updating recipes
type AddRecipe = {
    item_id: string;
    business_id: string;
    preparation_time: number;
    preparation_type: string;
    instructions: string;
    ingredients: { ingredient_id: string; quantity: number }[];
};

type UpdateRecipe = {
    recipe_id: string;
    preparation_time: number;
    preparation_type: string;
    instructions: string;
    ingredients: { ingredient_id: string; quantity: number }[];
};

// Action Types
export type RecipeManagementAction =
    | { type: typeof RecipeManagementActionTypes.RECIPE_ADD; payload: AddRecipe }
    | { type: typeof RecipeManagementActionTypes.RECIPE_ADD_SUCCESS; payload: { recipe: any } }
    | { type: typeof RecipeManagementActionTypes.RECIPE_ADD_ERROR; payload: { error: string } }
    | { type: typeof RecipeManagementActionTypes.RECIPE_LIST; payload: { business_id: string; item_id: string } }
    | { type: typeof RecipeManagementActionTypes.RECIPE_LIST_SUCCESS; payload: { recipe: any } }
    | { type: typeof RecipeManagementActionTypes.RECIPE_LIST_ERROR; payload: { error: string } }
    | { type: typeof RecipeManagementActionTypes.RECIPE_UPDATE; payload: UpdateRecipe }
    | { type: typeof RecipeManagementActionTypes.RECIPE_UPDATE_SUCCESS; payload: { recipe: any } }
    | { type: typeof RecipeManagementActionTypes.RECIPE_UPDATE_ERROR; payload: { error: string } }
    | { type: typeof RecipeManagementActionTypes.RECIPE_DELETE; payload: { recipe_id: string } }
    | { type: typeof RecipeManagementActionTypes.RECIPE_DELETE_SUCCESS; payload: { recipe_id: string } }
    | { type: typeof RecipeManagementActionTypes.RECIPE_DELETE_ERROR; payload: { error: string } }
    | { type: typeof RecipeManagementActionTypes.RECIPE_RESET };

// Action Creators
export const recipeAdd = (data: AddRecipe): RecipeManagementAction => ({
    type: RecipeManagementActionTypes.RECIPE_ADD,
    payload: data,
});

export const recipeAddSuccess = (recipe: any): RecipeManagementAction => ({
    type: RecipeManagementActionTypes.RECIPE_ADD_SUCCESS,
    payload: { recipe },
});

export const recipeAddError = (error: string): RecipeManagementAction => ({
    type: RecipeManagementActionTypes.RECIPE_ADD_ERROR,
    payload: { error },
});

export const recipeList = (business_id: string, item_id: string): RecipeManagementAction => ({
    type: RecipeManagementActionTypes.RECIPE_LIST,
    payload: { business_id, item_id },
});

export const recipeListSuccess = (recipe: any): RecipeManagementAction => ({
    type: RecipeManagementActionTypes.RECIPE_LIST_SUCCESS,
    payload: { recipe },
});

export const recipeListError = (error: string): RecipeManagementAction => ({
    type: RecipeManagementActionTypes.RECIPE_LIST_ERROR,
    payload: { error },
});

export const recipeUpdate = (data: UpdateRecipe): RecipeManagementAction => ({
    type: RecipeManagementActionTypes.RECIPE_UPDATE,
    payload: data,
});

export const recipeUpdateSuccess = (recipe: any): RecipeManagementAction => ({
    type: RecipeManagementActionTypes.RECIPE_UPDATE_SUCCESS,
    payload: { recipe },
});

export const recipeUpdateError = (error: string): RecipeManagementAction => ({
    type: RecipeManagementActionTypes.RECIPE_UPDATE_ERROR,
    payload: { error },
});

export const recipeDelete = (recipe_id: string): RecipeManagementAction => ({
    type: RecipeManagementActionTypes.RECIPE_DELETE,
    payload: { recipe_id },
});

export const recipeDeleteSuccess = (recipe_id: string): RecipeManagementAction => ({
    type: RecipeManagementActionTypes.RECIPE_DELETE_SUCCESS,
    payload: { recipe_id },
});

export const recipeDeleteError = (error: string): RecipeManagementAction => ({
    type: RecipeManagementActionTypes.RECIPE_DELETE_ERROR,
    payload: { error },
});

export const recipeReset = (): RecipeManagementAction => ({
    type: RecipeManagementActionTypes.RECIPE_RESET,
});
